// export const API=process.env.REACT_APP_API_URL
export const API = `https://mycommerce-iy3p.onrender.com/api`;